import lightbox from "../../node_modules/lightbox2/dist/js/lightbox-plus-jquery";
window.lightbox = lightbox;

window.lightbox.option({
  resizeDuration: 500,
  wrapAround: true,
  alwaysShowNavOnTouchDevices: true,
  disableScrolling: true,
  fadeDuration: 500,
  maxWidth: 1000,
  maxHeight: 800,
});
